import { ProgressNotifierContextData } from './ProgressNotifierContext.types';

export const INITIAL_CONTEXT_DATA: ProgressNotifierContextData = {
  state: [],
  dispatchNotification: () => '',
  dispatchNotifications: () => {},
  removeNotification: () => {},
  removeNotifications: () => {},
  updateNotification: () => {},
  handleError: () => '',
};
